import { BACKEND_URL } from '../../../configs'
import { alertError, alertSuccess, createJsonHeaders, logoutOnRequestOrResponseJson } from '../../../api'

export interface EmailConfig {
  id: number
  botId: number
  odinConfigId: string
  senderEmailId: string
  receiverEmailId: string
  redirectionEmailId: string
  isActive: boolean
  emailHealthStatus: string
}

export interface EmailConfigActivityItem {
  firstName: string
  lastName: string
  fileName: string
  createdAt: string
  status: string
}

export interface EmailConfigActivityResponse {
  hasNext: boolean
  page: number
  limit: number
  total: number
  items: EmailConfigActivityItem[]
}

export interface UpdateEmailConfigPayload {
  isActive: boolean
  receiverEmailId: string
  redirectionEmailId: string
  senderEmailId: string
}

export function getEmailConfig(botId: number): Promise<EmailConfig> {
  return fetch(`${BACKEND_URL}/admin/bot/${botId}/email-config`, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'GET',
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(response => {
      return response
    })
    .catch(error => {
      alertError('Failed to fetch email config')
      throw error
    })
}

export function updateEmailConfig(botId: number, payload: UpdateEmailConfigPayload): Promise<EmailConfig> {
  return fetch(`${BACKEND_URL}/admin/bot/${botId}/email-config`, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(response => {
      alertSuccess(response.message || 'Email automation updated successfully', 3000)
      return response
    })
    .catch(error => {
      alertError(error.message || 'Failed to update email automation')
      throw error
    })
}

export function updateEmailConfigById(botId: number, configId: number, payload: UpdateEmailConfigPayload): Promise<EmailConfig> {
  return fetch(`${BACKEND_URL}/admin/bot/${botId}/email-config/${configId}`, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'PUT',
    body: JSON.stringify(payload),
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(response => {
      alertSuccess(response.message || 'Email automation updated successfully', 3000)
      return response
    })
    .catch(error => {
      alertError(error.message || 'Failed to update email automation')
      throw error
    })
}

export function getEmailConfigActivity(botId: number, page = 1, limit = 10): Promise<EmailConfigActivityResponse> {
  return fetch(`${BACKEND_URL}/admin/bot/${botId}/email-config/activity?page=${page}&limit=${limit}`, {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'GET',
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(response => {
      return response
    })
    .catch(error => {
      alertError('Failed to fetch email automation activity')
      throw error
    })
}